import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import DeletedAssetsList from '../../../Component/Assets/AddAsset/deletedAssets';

const ListDeletedAsset = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="Assets" title="Deleted Assets List" />
      <DeletedAssetsList />
    </Fragment>
  );
};
export default ListDeletedAsset;